import './GlossaryModal.scss';
import { AlertDialog } from '@Components/AlertDialog';
import { GLOSSARY_ENTRIES } from './glossary-constants';

interface GlossaryModalProps {
  show: boolean;
  onHide: () => void;
}

const GlossaryBody = () => (
  <dl className='glossary'>
    {GLOSSARY_ENTRIES.map(entry => (
      <div key={entry.term} className='glossary-entry'>
        <dt className='glossary-term'>{entry.term}</dt>
        <dd className='glossary-def'>{entry.definition}</dd>
      </div>
    ))}
  </dl>
);

export const GlossaryModal = ({ show, onHide }: GlossaryModalProps) => (
  <AlertDialog
    show={show}
    onHide={onHide}
    title='Glossary'
    body={<GlossaryBody />}
    primaryAction={{ label: 'Close' }}
    className='glossary-dialog'
    passthroughProps={{ scrollable: true }}
  />
);
